import axios from "axios";
import React from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";
import { WEB_BASE_URL, UNIFIED_BASE_URL, CLIQ_BASE_URL } from "../../webbase";
import cookie from "react-cookies";
import { CSVLink } from "react-csv";
import Multiselect from "multiselect-react-dropdown";
import Select from "react-select";

class Transaction extends React.Component {
  constructor() {
    super();
    this.state = {
      token: cookie.load("token"),
      userRole: cookie.load("userRole"),
      walletBalance: cookie.load("walletBalance"),
      selectedTable: "Monthly",
      startDate: new Date(),
      endDate: new Date(),
      users: [],
      fromDate: this.makeShortDate(new Date()),
      toDate: this.makeShortDate(new Date()),
      transactions: [],
      walletHistory: [],
      dataByDate: {},
      isLoading: false,
      currentPage: 1,
      network: [
        { id: 1, name: "MTN" },
        { id: 2, name: "Airtel" },
        { id: 3, name: "Glo" },
        { id: 4, name: "9mobile" },
      ],
      filterOptions: [
        { id: 1, name: "Network" },
        { id: 2, name: "MSISDN" },
        { id: 3, name: "Beneficiary No" },
        { id: 4, name: "Merchant ID" },
      ],
      selectedFilters: [],
      msisdn: "",
      beneficiaryPhone: "",
      customerReference: "",
      selectedNetwork: "MTN",
      merchantId: "",
      status: "200",
      selectedDealer: "mobile@topupbox.com",
      totalTransactionFailed: "",
      totalTransactionCount: "",
      totalTransactionSuccessful: "",
      totalCountFailed: "",
      totalCountSuccessful: "",
    };
    //binding this to event-handler functions
    this.setStartDate = this.setStartDate.bind(this);
    this.setEndDate = this.setEndDate.bind(this);
    // this.getTransactions = this.getTransactions.bind(this);
    this.getDailyTransactions = this.getDailyTransactions.bind(this);
    this.getWeeklyTransactions = this.getWeeklyTransactions.bind(this);
    this.getCustomReport = this.getCustomReport.bind(this);
    this.reduceTransactions = this.reduceTransactions.bind(this);
    this.onSelectFilter = this.onSelectFilter.bind(this);
    this.onRemoveFilter = this.onRemoveFilter.bind(this);
    this.makeShortDate = this.makeShortDate.bind(this);
    this.getDealers = this.getDealers.bind(this);
  }

  onSelectFilter(selectedList, selectedItem) {
    this.setState({
      selectedFilters: selectedList,
    });
  }

  onRemoveFilter(selectedList, removedItem) {
    this.setState({
      selectedFilters: selectedList,
    });
  }
  makeShortDate(datew) {
    datew = new Date(datew);
    let yy = datew.getFullYear();
    let mm = datew.getMonth();
    let dd = datew.getDate();
    let shortDate = `${yy}/${mm < 10 ? 0 : ""}${mm + 1}/${
      dd < 10 ? 0 : ""
    }${dd}`;
    return shortDate;
  }

  setStartDate(date) {
    let datew = this.makeShortDate(date);

    this.setState({
      startDate: date,
      fromDate: datew,
    });
  }

  setEndDate(date) {
    let datew = this.makeShortDate(date);
    this.setState({
      endDate: date,
      toDate: datew,
    });
  }

  // getTransactions = () => {
  //     let api = "/admin/enterprise-monthly-report?dealerId=" + this.state.selectedDealer;
  //     axios
  //         .get(WEB_BASE_URL + api, {
  //             headers: {
  //                 authorization: this.state.token,
  //             },
  //         })
  //         .then((res) => {
  //             if (res.data.description === "No data available") {

  //             } else {
  //                 console.log(res.data.data);
  //                 const trans = res.data.data.data.data;
  //                 this.setState({ transactions: trans.reverse() });
  //             }
  //         })
  //         .catch((err) => {
  //             console.log(err)
  //             toast.error("Error fetching transactions");
  //         });
  // };

  getDailyTransactions = () => {
    const api = "/merchant/merchant-custom-report";
    const params = {
      startDate: this.state.fromDate.split("/").join("-"),
      endDate: this.state.toDate.split("/").join("-"),
      merchantEmail: this.state.selectedDealer,
      offSet: 0,
      page: 5,
      // statusCode: 2000
    };

    if (this.state.msisdn) params.beneficiaryPhone = this.state.msisdn;
    if (this.state.customerRef) params.customerRef = this.state.customerRef;
    if (this.state.statusCode) params.statusCode = this.state.statusCode;

    const queryString = Object.entries(params)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    axios
      .get(`${UNIFIED_BASE_URL}${api}?${queryString}`, {
        headers: {
          authorization: this.state.token,
        },
      })
      .then((res) => {
        if (res.data.status === "4000") {
          // Handle error status if needed
        } else {
          const trans = res.data.data;
          this.setState({
            transactions: trans,
            totalCountSuccessful: res.data.summary.totalCountSuccessful,
            totalTransactionFailed: res.data.summary.totalTransactionFailed,
            totalTransactionCount: res.data.summary.totalTransactionCount,
            totalTransactionSuccessful:
              res.data.summary.totalTransactionSuccessful,
            totalCountFailed: res.data.summary.totalCountFailed,
          });
          this.reduceTransactions(trans);
        }
      })
      .catch((err) => {
        toast.error("Error fetching transactions");
        console.log(err);
      });
  };

  getCustomReport() {
    this.setState({
      isLoading: true,
    });
    axios
      .get(
        WEB_BASE_URL +
          "/merchant/enterprise-custom-report?statusCode=200&startDate=" +
          this.state.fromDate.split("/").join("-") +
          "&endDate=" +
          this.state.toDate.split("/").join("-") +
          "&beneficiaryPhone=" +
          this.state.beneficiaryPhone +
          "&customerRef=" +
          this.state.customerReference +
          "&msisdn=" +
          this.state.msisdn +
          "&network=" +
          this.state.selectedNetwork +
          "&merchantEmail=" +
          this.state.selectedDealer,
        {
          headers: {
            authorization: this.state.token,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "2000" && res.data.data !== null) {
          console.log(res.data.data);
          this.setState({ transactions: res.data.data.data.reverse() });
        } else {
          toast.error("No data found");
          this.setState({ transactions: [] });
        }
      })
      .catch((err) => {
        console.log(WEB_BASE_URL + " " + err);
        toast.error("Error fetching transactions");
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  getWeeklyTransactions = () => {
    let api = "";
    api = "/admin/enterprise-weekly-report";

    axios
      .get(WEB_BASE_URL + api, {
        headers: {
          authorization: this.state.token,
        },
      })
      .then((res) => {
        if (res.data.description === "No data available") {
        } else {
          const trans = res.data.data.data;
          this.setState({ transactions: trans });
          this.reduceTransactions(trans);
        }
      })
      .catch((err) => {
        toast.error("Error fetching transactions");
      });
  };

  reduceTransactions(transactions) {
    const dataByDate = transactions.reduce((accumulator, transaction) => {
      const date = transaction.requestDate.split("T")[0];
      const amount = transaction.amount;
      if (!accumulator[date]) {
        accumulator[date] = 0;
      }
      accumulator[date] += amount;
      return accumulator;
    }, {});
    this.setState({ dataByDate });
  }

  getDealers() {
    console.log(this.state.token);
    axios
      .get(UNIFIED_BASE_URL + "/onboarding/stp-users", {
        headers: {
          authorization: `${this.state.token}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.status === "2000") {
          this.setState({
            users: res.data.data.merchants,
          });

          // this.getTransactions();
        } else {
          toast.error(res.data.description);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.getDealers();
    this.getDailyTransactions();
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if merchantEmail has changed
    if (
      prevState.selectedDealer !== this.state.selectedDealer ||
      prevState.fromDate !== this.state.fromDate ||
      prevState.toDate !== this.state.toDate
    ) {
      this.getDailyTransactions();
    }
  }
  render() {
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "NGN",
    });

    const pageSize = 15;
    let totalPages = 0;
    if (this.state.transactions.length !== 0) {
      totalPages = Math.ceil(this.state.transactions.length / pageSize);
    }

    const handlePageChange = (page) => {
      this.setState({ currentPage: page });
    };

    let transactionsToDisplay = this.state.transactions.slice(
      (this.state.currentPage - 1) * pageSize,
      this.state.currentPage * pageSize
    );
    return (
      <main className="page-content">
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
          <div className="ps-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  <a href="javascript:;">
                    <i className="bx bx-home-alt"></i>
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Transaction
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <form className="row">
              <div className="row">
                <div className="col-3">
                  <label className="form-label">From:</label>
                  <DatePicker
                    selected={this.state.startDate}
                    onSelect={(date) => this.setStartDate(date)}
                    onChange={(date) => this.setStartDate(date)}
                  />
                </div>
                <div className="col-3">
                  <label className="form-label">To:</label>
                  <DatePicker
                    selected={this.state.endDate}
                    onSelect={(date) => this.setEndDate(date)}
                    onChange={(date) => this.setEndDate(date)}
                  />
                </div>
                {/* <div className="col-3">
                                    <label className="form-label">Transaction Status</label>
                                    <select
                                        className="form-select "
                                        aria-label="Default select example"
                                        value={this.state.status}
                                        onChange={(event) => {
                                            this.setState({
                                                status: event.target.value,
                                            })
                                        }}>
                                        <option value="1">All</option>
                                        <option value="200">Success</option>
                                        <option value="5010">Failed</option>
                                    </select>
                                </div> */}
                {/* <div className="col-3">
                                    <label className="form-label">Filter</label>
                                    <Multiselect
                                        options={this.state.filterOptions} // Options to display in the dropdown
                                        selectedValues={this.state.selectedFilters} // Preselected value to persist in dropdown
                                        onSelect={this.onSelectFilter} // Function will trigger on select event
                                        onRemove={this.onRemoveFilter} // Function will trigger on remove event
                                        displayValue="name" // Property name to display in the dropdown options
                                        style={{
                                            chips: {
                                                borderRadius: "3px",
                                                backgroundColor: "#6c757d",
                                            }
                                        }}
                                        customCloseIcon={
                                            <i className="bi bi-x-circle-fill" style={{
                                                position: "absolute",
                                                right: "10px",
                                                top: "12px"
                                            }}></i>
                                        }
                                    />
                                </div> */}
              </div>
              {/* <div className="row mt-3">
                                {
                                    this.state.selectedFilters.find(filter => filter.name === "Network") &&
                                    <div className="col-3">
                                        <label className="form-label">Network</label>
                                        <select
                                            className="form-select "
                                            aria-label="Default select example"
                                            value={this.props.formRole}
                                            onChange={(event) => {
                                                this.setState({
                                                    selectedNetwork: event.target.value
                                                })
                                            }}
                                        >
                                            {
                                                this.state.network.map((network, index) => (
                                                    <option key={index} value={network.id}>{network.name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                }
                                {
                                    this.state.selectedFilters.find(filter => filter.name === "MSISDN") &&
                                    <div className="col-3">
                                        <label className="form-label">MSISDN</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="MSISDN"
                                            value={this.state.msisdn}
                                            onChange={(event) => {
                                                this.setState({
                                                    msisdn: event.target.value
                                                })
                                            }}
                                        />

                                    </div>
                                }
                                {
                                    this.state.selectedFilters.find(filter => filter.name === "Beneficiary No") &&
                                    <div className="col-3">
                                        <label className="form-label">Beneficiary No</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Beneficiary No"
                                            value={this.state.beneficiaryPhone}
                                            onChange={(event) => {
                                                this.setState({
                                                    beneficiaryPhone: event.target.value
                                                })
                                            }}
                                        />
                                    </div>
                                }
                                {
                                    this.state.selectedFilters.find(filter => filter.name === "Merchant ID") &&
                                    <div className="col-3">
                                        <label className="form-label">Merchant ID</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Merchant ID"
                                            value={this.state.merchantId}
                                            onChange={(event) => {
                                                this.setState({
                                                    merchantId: event.target.value
                                                })
                                            }}
                                        />
                                    </div>
                                }
                            </div>
                            <div className="row">
                                <div className="col-3 mt-3">
                                    <button
                                        className="btn btn-secondary d-flex"
                                        type="button"
                                        style={{
                                            width: "100%"
                                        }}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            this.getCustomReport();
                                        }}
                                    >
                                        <div>
                                            <i class="bi bi-arrow-clockwise"></i>
                                        </div>
                                        <div className="mx-1">
                                            {this.state.isLoading ? "Generating..." : "Generate report"}</div>
                                    </button>

                                </div>
                                <div className="col-3 mt-3">
                                    <CSVLink
                                        data={this.state.transactions}
                                        filename={"Topupbox Report.csv"}
                                        target="_blank"
                                    >
                                        <button
                                            className="btn btn-primary d-flex"
                                            type="button"
                                            style={{
                                                width: "100%"
                                            }}
                                        >
                                            <div>
                                                <i class="bi bi-cloud-arrow-down-fill"></i>
                                            </div>
                                            <div className="mx-1">Export report as CSV</div>
                                        </button>
                                    </CSVLink>
                                </div>
                            </div> */}
            </form>
          </div>
        </div>
        <div className="row row-cols-1 my-3 row-cols-lg-2 row-cols-xl-2 row-cols-xxl-4">
          <div className="col">
            <div className="card overflow-hidden radius-10">
              <div className="card-body">
                <div className="d-flex align-items-stretch justify-content-between overflow-hidden">
                  <div className="w-50">
                    <p>
                      Total <br></br>transaction successful
                    </p>
                    <h4 className="">
                      {this.state.totalTransactionSuccessful}
                    </h4>
                  </div>
                  <div className="w-50">
                    <p className="mb-3 float-end text-success"></p>
                    <div id="chart4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card overflow-hidden radius-10">
              <div className="card-body">
                <div className="d-flex align-items-stretch justify-content-between overflow-hidden">
                  <div className="w-50">
                    <p>
                      Total <br></br> transaction Failed
                    </p>
                    <h4 className="">{this.state.totalTransactionFailed}</h4>
                  </div>
                  <div className="w-50">
                    <p className="mb-3 float-end text-success"></p>
                    <div id="chart1"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card overflow-hidden radius-10">
              <div className="card-body">
                <div className="d-flex align-items-stretch justify-content-between overflow-hidden">
                  <div className="w-50">
                    <p>
                      Transaction failed <br></br> count
                    </p>
                    <h4 className="">{this.state.totalCountFailed}</h4>
                  </div>
                  <div className="w-50">
                    <p className="mb-3 float-end text-success"></p>
                    <div id="chart2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card overflow-hidden radius-10">
              <div className="card-body">
                <div className="d-flex align-items-stretch justify-content-between overflow-hidden">
                  <div className="w-50">
                    <p>Transaction successful count</p>
                    <h4 className="">{this.state.totalCountSuccessful}</h4>
                  </div>
                  <div className="w-50">
                    <p className="mb-3 float-end text-success"></p>
                    <div id="chart3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header py-3">
            <div className="row g-3">
              {/* <div className="col-lg-3 col-6 col-md-3">
                                <select
                                    className="form-select"
                                    value={this.state.selectedTable}
                                    onChange={(event) => {
                                        this.setState({
                                            selectedTable: event.target.value,
                                        });
                                        if (event.target.value === "Daily") {
                                            this.getDailyTransactions();
                                        }
                                        else if (event.target.value === "Weekly") {
                                            this.getWeeklyTransactions();
                                        }
                                        else if (event.target.value === "Monthly") {
                                            // this.getTransactions();
                                        }
                                    }}
                                >
                                    <option value="Daily">Daily</option>
                                    <option value="Weekly">Weekly</option>
                                    <option value="Monthly">Monthly</option>
                                </select>
                            </div> */}
              <div className="col-lg-3 col-6 col-md-3">
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  value={
                    this.state.users &&
                    this.state.users.find(
                      (merchant) =>
                        merchant.businessEmail === this.state.selectedDealer
                    )
                  }
                  onChange={(selectedOption) => {
                    this.setState({
                      selectedDealer: selectedOption?.businessEmail || "",
                    });
                  }}
                  options={this.state.users}
                  getOptionLabel={(option) => option.businessName}
                  getOptionValue={(option) => option.businessEmail}
                  placeholder="Select Merchant"
                  isClearable={true}
                  isSearchable={true}
                />
              </div>
              <div className="col-lg-3 col-md-6 me-auto">
                {/* <div className="ms-auto position-relative">
                                    <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                                        <i className="bi bi-search"></i>
                                    </div>
                                    <input
                                        className="form-control ps-5"
                                        type="text"
                                        placeholder="Search Payment"
                                    />
                                </div> */}
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table className="table align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Merchant</th>
                    <th>Network</th>
                    <th>Beneficiary</th>
                    <th>Amount</th>
                    <th>Type</th>
                    <th>Date</th>
                    <th>Current Balance</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {transactionsToDisplay.length !== 0 ? (
                    transactionsToDisplay.map((voucher, index) => (
                      <tr key={index}>
                        <td>
                          <div className="d-flex align-items-center gap-3">
                            <div className="product-info">
                              <h6 className="product-name mb-1">
                                {voucher.accountId}
                              </h6>
                            </div>
                          </div>
                        </td>
                        <td>{voucher?.networkId}</td>
                        <td>{voucher?.beneficiary}</td>
                        <td>{formatter.format(voucher.amount)}</td>
                        <td>{voucher.requestType}</td>
                        <td>
                          {voucher.requestDate !== undefined
                            ? voucher.requestDate.split("T")[0]
                            : 0}
                        </td>
                        <td>{formatter.format(voucher.newBalance)}</td>
                        <td>{voucher.statusMessage}</td>
                      </tr>
                    ))
                  ) : (
                    <tr colSpan="7">
                      <td>No Transaction Record.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {totalPages > 1 && (
              <nav class="float-end mt-3">
                <ul class="pagination">
                  {Array.from(Array(totalPages), (e, i) => {
                    let pageNumber = i + 1;
                    return (
                      <li
                        class={
                          "page-item " + this.state.currentPage == pageNumber &&
                          "active"
                        }
                      >
                        <a
                          class="page-link"
                          href="/2"
                          style={{
                            backgroundColor:
                              this.state.currentPage == pageNumber
                                ? "#0d6efd"
                                : "",
                            color:
                              this.state.currentPage == pageNumber ? "#fff" : "",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({
                              currentPage: pageNumber,
                            });
                          }}
                        >
                          {pageNumber}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </nav>
            )}
          </div>
        </div>
      </main>
    );
  }
}

export default Transaction;
